import styles from './styles.scss';

const bgColorMap = {
  black: styles.black,
  dark: styles.dark,
  white: styles.white,
  light: styles.light,
  grey: styles.grey,
  medium: styles.medium,
};
const bgClassMap = {
  [styles.black]: 'black',
  [styles.dark]: 'dark',
  [styles.white]: 'white',
  [styles.light]: 'light',
  [styles.grey]: 'grey',
  [styles.medium]: 'medium',
};
const fgColorMap = {
  white: styles.white,
  light: styles.light,
};
const bgColors = [bgColorMap.light, bgColorMap.medium, bgColorMap.dark, bgColorMap.white, bgColorMap.grey, bgColorMap.black];

export const getBackground = (index, reverse) => {
  if (!reverse) return bgColors[index % 3];
  return bgColors[+!(index % 3)]; // switch 0 and 1
};
export const startsReversed = (background) =>
  background === bgColorMap.medium || background === bgColorMap.grey;
export const getGivenBackground = (color) => bgColorMap[color || 'white'];
export const needsLightForground = (color) =>
  color !== bgColorMap.light && color !== bgColorMap.white;
export const getForeground = (color) => (needsLightForground(color) ? fgColorMap.light : null);

export const hasDarkBackground = (color) => color === bgColorMap.black || color === bgColorMap.dark;
export const hasMediumBackground = (color) =>
  color === bgColorMap.grey || color === bgColorMap.medium;

const isMediumBackground = (className) => [
  className.includes('medium'),
  className.includes('gray'),
  getGivenBackground(className) === 'medium',
  getGivenBackground(className) === 'gray',
  bgClassMap[className] === 'medium',
  bgClassMap[className] === 'gray',
].some((value) => value);

const isDarkBackground = (className) => [
  className.includes('dark'),
  className.includes('black'),
  getGivenBackground(className) === 'dark',
  getGivenBackground(className) === 'black',
  bgClassMap[className] === 'dark',
  bgClassMap[className] === 'black',
].some((value) => value);

export const getColorTypeFromClassName = (className) => {
  if (isDarkBackground(className)) {
    return 'dark';
  } else if (isMediumBackground(className)) {
    return 'medium';
  } else {
    return 'light';
  }
};
